import React from 'react'

import {
  Box,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Checkbox,
  Collapse,
} from '@material-ui/core'
import PersonIcon from '@material-ui/icons/PersonOutlineOutlined'
import SettingsIcon from '@material-ui/icons/SettingsOutlined'

import Footer from './../Footer'
import useContract from 'hooks/useContract'
import useCollapse from 'hooks/useCollapse'
import helpers from 'helpers'
import TableTaxes from 'views/Invoices/components/TableTaxes'
import AttachMoney from '@material-ui/icons/AttachMoneyOutlined'
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmarkOutlined'
import { Autocomplete } from '@material-ui/lab'

const Summary = () => {
  const { data, nextStep } = useContract()
  const collapse = useCollapse()

  const handleClickNextButton = () => nextStep()

  return (
    <>
      <Box p={3}>
        <Box display="flex" alignItems="center">
          <Box mr={4}>
            <PersonIcon fontSize="large" color="disabled" />
          </Box>
          <Box>
            <Typography variant="h5" color="textSecondary">
              Cliente
            </Typography>
          </Box>
        </Box>

        <Box
          mt={2}
          display="flex"
          flexGrow={1}
          flexDirection={{
            xs: 'column',
            sm: 'row',
          }}
        >
          <Box flex={1} mr={5} width="100%">
            <TextField
              margin="dense"
              label="Nome/Fantasia"
              value={
                helpers.people.isCompany(data.customer.kind)
                  ? data.customer.tradeName
                  : data.customer.name
              }
              variant="outlined"
              fullWidth
              disabled
            />
            <TextField
              margin="dense"
              label="E-mail"
              value={data.customer.email}
              variant="outlined"
              fullWidth
              disabled
            />
          </Box>
          <Box flex={1}>
            <TextField
              margin="dense"
              label="CPF/CNPJ"
              value={
                helpers.people.isCompany(data.customer.kind)
                  ? helpers.people.formatCnpj(data.customer.cnpj)
                  : helpers.people.formatCpf(data.customer.cpf)
              }
              variant="outlined"
              fullWidth
              disabled
            />
            <TextField
              margin="dense"
              label="Pessoa"
              value={helpers.people.kind(data.customer.kind)}
              variant="outlined"
              fullWidth
              disabled
            />
          </Box>
        </Box>

        <Box display="flex" alignItems="center" mt={6}>
          <Box mr={4}>
            <SettingsIcon fontSize="large" color="disabled" />
          </Box>
          <Box>
            <Typography variant="h5" color="textSecondary">
              Configurações da assinatura
            </Typography>
          </Box>
        </Box>

        <Box mt={2} mb={6} display="flex" flexGrow={1} flexDirection="column">
          <Box
            display="flex"
            flexDirection={{
              xs: 'column',
              sm: 'row',
            }}
          >
            <Box flex={1}>
              <RadioGroup
                aria-label="payment"
                name="payment"
                value={data.contract.payment}
                row
              >
                <FormControlLabel
                  value="prepaid"
                  control={<Radio />}
                  label="Pré-paga"
                  disabled
                />
                <FormControlLabel
                  value="postpaid"
                  control={<Radio />}
                  label="Pós-paga"
                  disabled
                />
              </RadioGroup>
              <Box
                display="flex"
                flexDirection={{
                  xs: 'column',
                  sm: 'row',
                }}
              >
                <Box mr={5} width="100%">
                  <TextField
                    margin="dense"
                    label="Dia de vencimento da assinatura"
                    value={
                      data.contract.payment === 'postpaid'
                        ? data.contract.dayExpiration
                        : 'Um dia após ativação'
                    }
                    variant="outlined"
                    fullWidth
                    disabled
                  />
                </Box>
                <TextField
                  margin="dense"
                  label="URL para envio de notificações"
                  value={data.contract.urlNotification}
                  variant="outlined"
                  fullWidth
                  disabled
                />
              </Box>
              <Autocomplete
                size="small"
                value={data.contract.contractEmails}
                options={[]}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Emails adicionais de notificação"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                )}
                disabled
                autoSelect
                freeSolo
                multiple
              />
            </Box>
          </Box>
        </Box>

        <Box mb={6}>
          <Box mb={2} mt={2}>
            <Typography variant="h5" color="textSecondary">
              Faturas
            </Typography>
          </Box>
          <Box
            mt={2}
            display="flex"
            flexDirection={{
              xs: 'column',
              sm: 'row',
            }}
          >
            <Box mr={5} width="100%">
              <TextField
                margin="dense"
                label="Dias para vencimento da fatura"
                value={data.contract.settings.daysToOverdueInvoice}
                variant="outlined"
                fullWidth
                disabled
              />
            </Box>

            <Box width="100%">
              <TextField
                margin="dense"
                label="Dias para geração da fatura antes do vencimento da assinatura"
                value={helpers.formatNumber.formatNumberToString(
                  data?.contract?.settings?.invoiceInterval,
                )}
                variant="outlined"
                fullWidth
                disabled
              />
              <FormControlLabel
                control={<Checkbox />}
                label={`Utilizar configuração geral do vendedor (${data.generalSettings.invoiceInterval} dias)`}
                checked={
                  !helpers.formatNumber.isNumber(
                    data.contract.settings.invoiceInterval,
                  )
                }
                disabled
              />
            </Box>
          </Box>
        </Box>

        <Box mb={6}>
          <Box mb={2} mt={2}>
            <Typography variant="h5" color="textSecondary">
              Notas fiscais
            </Typography>
          </Box>

          <Typography variant="h6" color="textSecondary">
            Deseja emitir notas fiscais das faturas?
          </Typography>

          <RadioGroup
            aria-label="settings.generateServiceTaxInvoices"
            name="settings.generateServiceTaxInvoices"
            value={data.contract.settings.generateServiceTaxInvoices}
            row
          >
            <FormControlLabel
              value={true}
              control={<Radio />}
              label="Sim"
              disabled
            />
            <FormControlLabel
              value={false}
              control={<Radio />}
              label="Não"
              disabled
            />
          </RadioGroup>

          <Collapse in={data.contract.settings.generateServiceTaxInvoices}>
            <Box mb={2}>
              <TextField
                margin="dense"
                label="Dias para geração da NFe antes do vencimento da fatura"
                value={helpers.formatNumber.formatNumberToString(
                  data?.contract?.settings?.daysToGenerateNfe,
                )}
                variant="outlined"
                fullWidth
                disabled
              />
              <FormControlLabel
                control={<Checkbox />}
                label={`Utilizar configuração geral do vendedor (${
                  data.generalSettings.generateNfeOnInvoiceCreation
                    ? 'Na criação da fatura'
                    : data.generalSettings.daysToGenerateNfe + ' dias'
                })`}
                checked={
                  !helpers.formatNumber.isNumber(
                    data.contract.settings.daysToGenerateNfe,
                  )
                }
                disabled
              />
            </Box>
            <TextField
              label="Descrição fixa nas notas fiscais"
              value={data.contract.settings.fixedTaxInvoiceDescription}
              margin="dense"
              type="text"
              multiline
              rows={2}
              disabled
              fullWidth
            />
          </Collapse>
        </Box>

        <Box display="flex" alignItems="center" mt={6}>
          <Box mr={4}>
            <AttachMoney fontSize="large" color="disabled" />
          </Box>
          <Box>
            <Typography variant="h5" color="textSecondary">
              Impostos
            </Typography>
          </Box>
        </Box>
        <Box mt={2}>
          <TableTaxes taxes={data.contract.taxes} readOnly={true} />
        </Box>

        <Box display="flex" alignItems="center" mt={6}>
          <Box mr={4}>
            <CollectionsBookmarkIcon fontSize="large" color="disabled" />
          </Box>
          <Box>
            <Typography variant="h5" color="textSecondary">
              Planos
            </Typography>
          </Box>
        </Box>

        {collapse.data.map(contractPlan => (
          <Box
            mt={2}
            mb={4}
            display="flex"
            flexGrow={1}
            flexDirection={{
              xs: 'column',
              sm: 'row',
            }}
            key={contractPlan.collapseId}
          >
            <Box flex={1} mr={5} width="100%">
              <TextField
                margin="dense"
                label="Plano"
                value={
                  contractPlan.plan?.name || contractPlan.plan?.description
                }
                variant="outlined"
                fullWidth
                disabled
              />
              <TextField
                margin="dense"
                label="Periodicidade"
                value={contractPlan.periodicity}
                variant="outlined"
                fullWidth
                disabled
              />
              <TextField
                margin="dense"
                label="Quantidade de desconto"
                value={
                  helpers.contractPlanEntries.isRecurring(
                    contractPlan.contractPlanEntries[0].quantity,
                  )
                    ? 'Recorrente'
                    : contractPlan.contractPlanEntries[0].quantity
                }
                variant="outlined"
                fullWidth
                disabled
              />
            </Box>

            <Box flex={1}>
              <TextField
                margin="dense"
                label="Valor"
                value={helpers.currency(contractPlan.price)}
                variant="outlined"
                fullWidth
                disabled
              />
              <TextField
                margin="dense"
                label="Quantidade"
                value={
                  helpers.contractPlans.isRecurring(contractPlan.quantity)
                    ? 'Recorrente'
                    : contractPlan.quantity
                }
                variant="outlined"
                fullWidth
                disabled
              />
              <TextField
                margin="dense"
                label="Valor do desconto"
                value={helpers.currency(
                  contractPlan.contractPlanEntries[0].price,
                )}
                variant="outlined"
                fullWidth
                disabled
              />
            </Box>
          </Box>
        ))}
      </Box>
      <Footer nextButtonProps={{ onClick: handleClickNextButton }} />
    </>
  )
}

export default Summary
